 import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "918600082700"; // Replace with your number (with country code)
  const message = "Hello! I'm interested in your services."; // Optional prefilled message
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
<a
  href={whatsappLink}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 9999,
  }}
>
  <img
    src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
    alt="WhatsApp"
    style={{
      width: "50px",
      height: "50px",
      border: "2px solid #25D366", // WhatsApp green color
      borderRadius: "50%",
      padding: "5px",
      backgroundColor: "#fff"
    }}
  />
</a>

  
  );
};

export default WhatsAppButton;
